<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { StatusApiDataRequestType } from './WidgetOneApi';
    import VehicleOneSection from '../../components/Vehicles/VehicleOneSection.svelte';
    import VehicleOneValue from '../../components/Vehicles/VehicleOneValue.svelte';
    import Select from '../Select.svelte';
    import LastmileFilter from '../LastmileFilter.svelte';
    import { api, jobs_filter_config } from '../../../stores/api';
    import type { DashboardComponentType } from './WidgetManager';
    import { onMount } from 'svelte';
    import { SettingsApi } from '../../components/Settings/SettingsApi';
    import type { LastMileConfigResponseType } from '../../components/Settings/settings';
    import Spinner from '../Spinner/Spinner.svelte';
    import { planning } from '../../../stores/store';
    import SelectDay from '../SelectDay.svelte';

    export let settings: StatusApiDataRequestType;
    export let dashboardItem: DashboardComponentType;
    export let allowSave: boolean;

    let intervalItems: { id: string; label: string }[] = [
        { id: '0', label: 'dont_refresh' },
        { id: '1', label: 'every minute' },
        { id: '2', label: 'every 2 minutes' },
        { id: '3', label: 'every 3 minutes' },
        { id: '4', label: 'every 4 minutes' },
        { id: '5', label: 'every 5 minutes' },
        { id: '10', label: 'every 10 minutes' },
        { id: '15', label: 'every 15 minutes' },
    ];

    function getFilterManagerStorageKey() {
        return 'lastmile_filter_manager_' + dashboardItem.id;
    }

    let filterConfig: LastMileConfigResponseType | null = null;
    let filterManagerStorageKey = getFilterManagerStorageKey();
    let collectionName = dashboardItem.settingsOptions.collectionName; // `jobs` by default

    onMount(() => {
        console.log(
            'gantt, dashboardItem.settingsOptions.collectionName',
            dashboardItem.settingsOptions.collectionName
        );
        if (dashboardItem.settingsOptions.collectionName === 'assignments') {
            SettingsApi.getFilterConfig($api, 'assignments').then(config => {
                console.log('gantt, settings, filterConfig', config);
                filterConfig = config;
            });
        } else {
            filterConfig = $jobs_filter_config;
        }
    });

    $: {
        console.log('settings, load', allowSave, settings);
        settings = settings;
    }

    let today = new Date();
</script>

<div style="display: flex; flex-direction: column; row-gap: 12px;">
    {#if dashboardItem.settingsOptions.reloadInterval}
        <VehicleOneSection>
            <VehicleOneValue>
                {$_('Reload')}
                <Select
                    items={intervalItems}
                    selected={(settings.reloadIntervalSeconds / 60).toString() ?? '5'}
                    onChange={v => {
                        settings.reloadIntervalSeconds = parseInt(v) * 60;
                        settings = settings;
                        console.log('settings, set', settings);
                        return true;
                    }}
                />
            </VehicleOneValue>
        </VehicleOneSection>
    {/if}
    {#if dashboardItem.settingsOptions.useSelectedDay}
        <VehicleOneSection>
            <VehicleOneValue>
                {$_('Wybrany dzień')}
                <SelectDay
                    day={settings.selectedDay ?? $planning.selectedDay}
                    onChange={v => {
                        settings.selectedDay = v;
                        settings = settings;
                        console.log('settings, set', settings);
                        return true;
                    }}
                />
            </VehicleOneValue>
        </VehicleOneSection>
    {/if}
    {#if dashboardItem.settingsOptions.filter}
        <VehicleOneSection>
            <VehicleOneValue>
                {#if filterConfig}
                    <LastmileFilter
                        {collectionName}
                        onChange={queries => {
                            console.log('settings, queries', queries);
                            settings.query = queries;
                        }}
                        showQuickFilters={false}
                        {filterConfig}
                        enableInactiveQueries={true}
                        {filterManagerStorageKey}
                        visibleFilterIcon={false}
                    />
                {:else}
                    <Spinner />
                {/if}
            </VehicleOneValue>
        </VehicleOneSection>
    {/if}
</div>
